module.exports = __webpack_public_path__ + "img/TW.a21d97ba.svg";